/**
 * Вычисляет относительную яркость hex-цвета по стандарту WCAG
 * @param {string} hex - Цвет в формате "#rrggbb"
 * @returns {number} Яркость от 0 до 1
 */
function getLuminance(hex) {
  const clean = hex.replace("#", "");
  const r = parseInt(clean.substring(0, 2), 16) / 255;
  const g = parseInt(clean.substring(2, 4), 16) / 255;
  const b = parseInt(clean.substring(4, 6), 16) / 255;
  const toLinear = (c) =>
    c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  return 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);
}

/**
 * Возвращает цвет текста (--color-dark или #fff) с достаточным контрастом для заданного фона
 * @param {string|null} hex - Цвет фона в формате "#rrggbb"
 * @returns {string} CSS-значение цвета текста
 */
export function getContrastColor(hex) {
  if (!hex) return "#fff";
  return getLuminance(hex) > 0.35 ? "var(--color-dark)" : "#fff";
}
